import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
    return (
        <div className="max-w-4xl mx-auto py-8">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-6 sm:p-8 lg:p-12">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">Terms & Conditions</h1>
                <p className="text-gray-600 dark:text-gray-400 mb-8">Last updated: January 2025</p>

                <div className="prose prose-gray max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. Acceptance of Terms</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            By accessing and using RewriteKing, you accept and agree to be bound by the terms and 
                            provision of this agreement. If you do not agree to these terms, please do not use our service.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. Use License</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Permission is granted to temporarily use RewriteKing for personal, non-commercial transitory 
                            viewing only. This is the grant of a license, not a transfer of title, and under this license 
                            you may not:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 ml-4">
                            <li>Modify or copy the materials</li>
                            <li>Use the materials for any commercial purpose or for any public display</li>
                            <li>Attempt to reverse engineer any software contained on RewriteKing</li>
                            <li>Remove any copyright or other proprietary notations from the materials</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. Service Usage</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            RewriteKing provides AI-powered text rewriting services. You agree to:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Use the service only for lawful purposes</li>
                            <li>Not transmit any harmful, offensive, or illegal content</li>
                            <li>Not attempt to gain unauthorized access to our systems</li>
                            <li>Respect intellectual property rights</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. User Content</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            You retain ownership of any text content you submit to RewriteKing. By using our service, you 
                            grant us a limited license to process your content solely for the purpose of providing the 
                            rewriting service. We do not store or share your content with third parties.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Disclaimer</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            The materials on RewriteKing are provided on an 'as is' basis. RewriteKing makes no warranties, 
                            expressed or implied, and hereby disclaims all other warranties including, without limitation, 
                            implied warranties or conditions of merchantability, fitness for a particular purpose, or 
                            non-infringement of intellectual property or other violation of rights.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Limitations</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            In no event shall RewriteKing or its suppliers be liable for any damages (including, without 
                            limitation, damages for loss of data or profit, or due to business interruption) arising out of 
                            the use or inability to use the materials on RewriteKing, even if RewriteKing or an authorized 
                            representative has been notified orally or in writing of the possibility of such damage.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">7. Modifications</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            RewriteKing may revise these terms of service at any time without notice. By using this service, 
                            you are agreeing to be bound by the then current version of these terms.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">8. Contact Information</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Questions about the Terms & Conditions should be sent to us at{' '}
                            <a href="mailto:legal@rewriteking.com" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300">
                                legal@rewriteking.com
                            </a>
                        </p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
                    <Link to="/" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium">
                        ← Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;

